import { render, staticRenderFns } from "./submit-list.vue?vue&type=template&id=5fc0599e&"
import script from "./submit-list.vue?vue&type=script&lang=js&"
export * from "./submit-list.vue?vue&type=script&lang=js&"
import style0 from "./submit-list.vue?vue&type=style&index=0&id=5fc0599e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports